import React from 'react';
import { localeService } from '../../../core';
export const CallSurveyHeader = ({ title, subtitle, titleId }) => {
    return (<div className="call-quality-survey__header">
      <div id={titleId} className="call-quality-survey__title">
        {localeService.formatMessageById(title)}
      </div>
      <div className="call-quality-survey__subtitle">
        {localeService.formatMessageById(subtitle)}
      </div>
    </div>);
};
